import {
  Alert,
  Box,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { NavLink } from "react-router";
import { Latest, Next } from "src/store/api/generatedApi";

interface Props {
  value: Latest | Next;
}

export const LatestNextToggle = ({ value }: Props) => {
  const theme = useTheme();
  const { t } = useTenantTranslation();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {value === "next" ? (
        <Alert variant="outlined" severity="warning" sx={{ paddingY: 0 }}>
          {t("youAreCurrentlyViewingTheNextPlan")}
        </Alert>
      ) : null}
      <ToggleButtonGroup
        sx={{
          borderColor: theme.palette.grey[500],
          "& .MuiToggleButton-root": {
            fontWeight: theme.typography.fontWeightSemiBold,
          },
        }}
        color="primary"
        size="small"
        value={value}
        exclusive
      >
        <NavLink to="../standard/latest">
          <ToggleButton
            sx={{
              borderColor:
                value === "latest"
                  ? theme.palette.primary.main
                  : theme.palette.grey[500],
            }}
            value="latest"
          >
            {t("latest")}
          </ToggleButton>
        </NavLink>
        <NavLink to="../standard/next">
          <ToggleButton
            sx={{
              borderColor:
                value === "next"
                  ? theme.palette.primary.main
                  : theme.palette.grey[500],
            }}
            value="next"
          >
            {t("next")}
          </ToggleButton>
        </NavLink>
      </ToggleButtonGroup>
    </Box>
  );
};
